import './ReviewStack.css'

const cloudName = 'dqyt74s85';

const DesignCard = (props) => {
    const publicId = props.design.image_id;
    const viewportHeight = Math.round(window.innerHeight * 0.65); // Get viewport height in pixels
    const viewportWidth = Math.round(window.innerHeight * 1);   // Get viewport width in pixels
    console.log(publicId);
    console.log(viewportHeight + ' ' + viewportWidth);
    const imageUrl = `https://res.cloudinary.com/${cloudName}/image/upload/${publicId}`;
    return (
        <img src={imageUrl} className='img' />
    )
}

export default DesignCard;